module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALwAAABGBAMAAACEbuPnAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAACRQTFRFAAAA8WYiiHFuj4Bwv4BAmXdm5mYa6mYlpG1b72YjsXZO0XQuqm6sqQAAAAx0Uk5TAP++EAwPCp0O6A0Lle2GeAAAAG1JREFUeJzt2DERgEAMBdFU10cCDpAADpDAzTBgAws4OAlIJCa2YrdI+ebXiWBLNHl5eXl5eXl5eXl5eXl5eXl5eXn5v/NTnZl78q7Fbxx/FX9zfHtQPnrmAPkzcwH51vMF+ZqP8q3vJB8Hy4N9katzfNdidLkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/control/check_stop.png
// module id = 835
// module chunks = 0